export const date = 'date';
export const time = 'time';
export const party_size = 'party_size';
export const table = 'table';


export const confirmed = 'Confirmed';
export const canceled = 'Canceled';
export const cancelled = 'Cancelled';